import React from 'react';
import { Field } from 'formik';
import ListBuilder from '../ListBuilder';

const FormikListBuilder = (props) => (
    <Field
        variant="outlined"
        {...props}
    >
        {({ field: { name, value }, form: { setFieldValue } }) => (
            <ListBuilder
                name={name}
                listItems={value}
                setListItems={setFieldValue}
            />
        )}
    </Field>
);

export default FormikListBuilder;
